module.exports = __webpack_public_path__ + "static/media/add_entry_to_list_ja.82a0e3b0.gif";